import { MprcRequestIndicator } from 'components';
import { MprcRequestSnackbarErrorReport } from 'components/MprcRequestErrorReport';
import { useSnackbar } from 'notistack';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////////

interface IProps {
    publicationId: string;
    onClose: (success: boolean | null) => void;
}

////////////////////////////////////////////////////////////////////////////////

export const UnblockPublication: React.FC<IProps> = (props) => {

    const { publicationId, onClose } = props;

    const api = useCoreApi();
    const { t } = useTranslation("knowledge");
    const { enqueueSnackbar } = useSnackbar();

    const [saving, setSaving] = React.useState<boolean>(false);

    ///
    const unblockPublication = () => {
        setSaving(true);
        api.v1.knowledgePublication.unblockPublication({ publicationId })
            .then((result) => {
                if (result.data === true) {
                    enqueueSnackbar(t("Feed.Card.Actions.UnblockPublication.SuccessMessage"), { variant: "success" });
                    onClose(true);
                }
                else {
                    enqueueSnackbar(t("Feed.Card.Actions.UnblockPublication.FailMessage"), { variant: "error" });
                    onClose(false);
                }
            })
            .catch(e => {
                MprcRequestSnackbarErrorReport(e);
                onClose(false);
            })
            .finally(() => {
                setSaving(false);
            });
    };

    useEffect(() => {
        unblockPublication();
    }, []);

    return <MprcRequestIndicator type={"post"} visible={saving} />;
};
